var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackNewChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File / Note_Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33348 3.83333L6.00014 3.83333C5.06672 3.83333 4.59966 3.83333 4.24314 4.01499C3.92954 4.17478 3.67476 4.42956 3.51497 4.74317C3.33331 5.09968 3.33331 5.56674 3.33331 6.50016L3.33331 14.5002C3.33331 15.4336 3.33331 15.9001 3.51497 16.2566C3.67476 16.5702 3.92954 16.8254 4.24314 16.9852C4.59931 17.1667 5.06581 17.1667 5.9974 17.1667H14.0026C14.9342 17.1667 15.4 17.1667 15.7561 16.9852C16.0697 16.8254 16.3254 16.5699 16.4852 16.2563C16.6666 15.9002 16.6666 15.4342 16.6666 14.5026V12.1667M13.3333 4.66667L8.33331 9.66667L8.33331 12.1667L10.8333 12.1667L15.8333 7.16667M13.3333 4.66667L15.8333 2.16667L18.3333 4.66667L15.8333 7.16667M13.3333 4.66667L15.8333 7.16667",
    stroke: "#354570",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackNewChatIcon);
export default __webpack_public_path__ + "static/media/black_new_chat_icon.1932adf39382c24688876ca0f8e7fdcb.svg";
export { ForwardRef as ReactComponent };